"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiomCircuit = void 0;
const tslib_1 = require("tslib");
const web_1 = require("@axiom-crypto/circuit/web/");
const sendQuery_1 = require("../sendQuery");
class AxiomCircuit extends web_1.AxiomBaseCircuit {
    constructor(inputs) {
        super(inputs);
    }
    async getSendQueryArgs(input) {
        if (!this.computeQuery)
            throw new Error("No compute query generated");
        const axiomCallback = {
            target: input.callbackTarget,
            extraData: input.callbackExtraData,
        };
        return await (0, sendQuery_1.buildSendQuery)({
            axiom: this.axiom,
            dataQuery: this.dataQuery,
            computeQuery: this.computeQuery,
            callback: axiomCallback,
            caller: input.callerAddress,
            options: input.options,
        });
    }
}
exports.AxiomCircuit = AxiomCircuit;
tslib_1.__exportStar(require("../sendQuery"), exports);
tslib_1.__exportStar(require("@axiom-crypto/circuit"), exports);
//# sourceMappingURL=index.js.map